import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const MAX_PATH_LEN = 80

export function sanitizePath(raw: string): string {
  return raw.replace(/[^\w\-/%.=?&]/g, '').slice(0, MAX_PATH_LEN)
}

/**
 * Encurta um UUID ou ID longo para exibição (ex: c0000000-0000... -> c0000000)
 */
export function formatId(id: string | null | undefined, length = 8): string {
  if (!id) return '—'
  if (id.length <= length) return id
  return `${id.slice(0, length)}…`
}
